<template>
	<Fullscreen ref="fullscreen" @change="fullscreenChange" class="full-screen" id="full-screen">
		<md-app class="full-screen" id="app">
			<md-app-content id="content" class="full-screen">

				<!-- MaximizedVideoPanel Dialogue -->
				<transition name="fade">
					<MaximizedVideoPanel v-if="maximizedVideoPanelVisible"/>
				</transition>

				<!-- Navigation Bar -->
				<md-app-toolbar class="md-transparent md-dense flux-nav-toolbar disablePointer" md-elevation="0" style="width: 100%; height: 100%; position:relative;">
					<div class="md-layout" style="width:100%;">
						<div class="md-layout-item md-size-25  md-layout md-alignment-top-left md-xsmall-hide">
							<!-- <TourInfo class="tourInfo enabelPointer"></TourInfo> -->
						</div>
						<div id="navbar-center" class="md-layout-item md-layout md-size-50 md-xsmall-size-100 md-alignment-top-center md-layout-nowrap">
							<!-- <md-button v-if="enableMap" :md-ripple="false" class="md-icon-button enabelPointer" :class="{ 'active': mapVisible }" @click="toggleMap" style="margin-right: 5px">
								<MapOutline class="mapIcon"/>
							</md-button>														
							<md-button class="md-icon-button enabelPointer" @click="toggleGallery" id="Trigger" style="height: 50px; width: auto; text-transform: none; margin: 0 10px">
								<span class="situationName enabelPointer" style="margin: 0 10px;">{{currentSituationName}}</span>	
								<ChevronDown v-if="!situationGalleryVisible"/>
								<ChevronUp v-if="situationGalleryVisible"/>
							</md-button> -->
						</div> 
						<div class="md-layout-item md-layout md-size-25 md-xsmall-size-40 md-alignment-top-right md-layout-nowrap md-xsmall-hide">
							<md-button v-if="isVideoPanorama && !enablePermanentPanoramaVideoControls" :md-ripple="false" class="md-icon-button enabelPointer" :class="{ 'active': mediaControlsVisible }" @click="toggleMediaControls">
								<img src="@/assets/ic_mediaControl.svg" alt="" style="width:28px; height: auto;">
							</md-button>								
							<ModeratorMenu class="enabelPointer" v-show="this.localUserIsModerator"/>						
							<md-button :md-ripple="false" class="md-icon-button enabelPointer" :class="{ 'active': screenSharingVisible, 'notification': screenCastsAvailable && !screenSharingVisible }" @click="toggleScreenSharing" v-if="displayScreenSharing && !localUserIsModerator">	<MonitorShareIcon/>
							</md-button>
							<md-button :md-ripple="false" class="md-icon-button enabelPointer" :class="{ 'active': fullScreen }" @click="toggleFullScreen" style="margin: 0 5px">
								<FullScreenIcon v-if="!fullScreen"/>
								<FullScreenExitIcon v-if="fullScreen"/>
							</md-button>
							<md-button v-if="enableSharing" :md-ripple="false" class="md-icon-button enabelPointer" :class="{ 'active': sharingVisible }" @click="toggleSharing" style="margin: 0 5px">
								<ShareIcon/>
							</md-button>
							<md-button v-if="!loggedIn && enableCommunication" :md-ripple="false" class="registrBtn md-icon-button enabelPointer" :class="{ 'active': loginDialogueVisible, 'inactive': !loginDialogueVisible }"  @click="toggleLoginDialogue()" style="margin-top: -8px; height: 60px; border-radius: 5px 0 0 5px; margin-left: 10px; padding: 0 1.2rem; width:auto">
								<!-- <Login/> -->
								<span style="color: white; font-weight: 600">{{$t("Anmelden")}}</span>
							</md-button>
							<md-button v-if="loggedIn && enableCommunication" class="md-icon-button enabelPointer" @click="toggleCommunication" style="margin-top: -8px; height: 60px; background:rgba(48, 47, 47, 0.767); border-radius: 5px 0 0 5px; margin-left: 10px">
								<AccountGroup v-if="!comVisible"/>
								<ChevronRight v-if="comVisible"/>
							</md-button>	
						</div>
					</div>					
					<!-- Situation Gallery	-->
					<!-- <div class="md-layout" style="position: absolute; top: 75px; width: 100%; pointer-events: all;" :class="{slideup:!situationGalleryVisible, slidedown:situationGalleryVisible}">
						<SituationGallery/>
					</div> -->
					<div class="corner-right">
						<md-button v-if="gyrosSupported" :md-ripple="false" class="md-icon-button enabelPointer" @click="toggleGyros" :class="{ 'active': gyrosActive }" style="margin-right: 10px; height: 45px; width: 45px; background:rgba(48, 47, 47, 0.767); border-radius: 5px;">
							<img src="@/assets/gyrosicon.png" alt="" style="width:28px; height: auto;"/>
						</md-button>
						<md-button v-if="enableBugReport" :md-ripple="false" class="md-icon-button enabelPointer" @click="toggleBugReport" :class="{ 'active': bugReportVisible }" style="height: 45px; width: 45px; background:rgba(48, 47, 47, 0.767); border-radius: 5px;">
							<img src="@/assets/bugreport icon.png" alt="" style="width:28px; height: auto;"/>
						</md-button>
					</div>
				</md-app-toolbar>

				<!-- Rendering -->
				<Flux360/>

				<!-- Loadingscreen between Situations -->
				<transition name="fadeLoadingscreen">
					<Loadingscreen v-show="loadingscreenVisible"/>
				</transition>

				<!-- Preview of Transition on hover over -->
				<TransitionPreview/>

				<!-- BugReport Dialogue -->
				<transition name="fade">
					<BugReportDialogue v-if="bugReportVisible"/>
				</transition>

				<!-- Login Dialogue -->
				<transition name="fade">
					<LoginDialogue :toggleLogin="this.toggleLogin" :loginDialogueVisible="this.loginDialogueVisible" v-show="loginDialogueVisible"/>
				</transition>

				<!-- AudioVideo Dialogue -->
				<!-- <transition name="fade">
					<AudioVideoDialogue v-if="$store.state.session.showAudioVideoSettings" class="audio-video-settings" id="audio-video-settings" from="app"/>
				</transition> -->

				<!-- Map Dialogue-->
				<transition name="fade">
					<MapDialogue v-if="enableMap" v-show="mapVisible"/>
				</transition>

				<!-- Share Dialogue -->
				<transition name="fade">
					<ShareDialogue v-if="sharingVisible"/> <!-- v-if because listening to url changes not working currently -->
				</transition>
				
				<!-- Website Dialogue -->				
				<WebsiteDialogue/>
				
				<!-- Viewer3D Dialogue -->				
				<Viewer3D/>

				<!-- VideoGallery Dialogue -->				
				<VideoGallery/>

				<!-- MeetingRegister Dialogue -->				
				<MeetingRegister/>

				<!-- ForcedDisconnect Dialogue -->				
				<ForcedDisconnect/>

				<!-- Venjakob Rooms -->
				<Praxisvortraege v-show="currentSituationID == 293932"/>
				<StreamingVideo v-if="currentSituationID == 295526"/>
				<Betriebsfuehrung v-if="currentSituationID == 300437"/>
				<ReceptionStream v-if="currentSituationID == 280866"/>

				<!-- WaitForModerator Dialogue -->				
				<!-- <WaitForModerator/> -->
				
				<!-- Screen Sharing Panel -->
				<transition name="fade">
					<ScreenSharingPanel v-if="screenSharingVisibleOrNoScreens"/>
				</transition>

				<!-- Media Controls -->
				<transition name="fade">
					<MediaController v-show="enablePermanentPanoramaVideoControls ? isVideoPanorama: mediaControlsVisible"/>			
				</transition>

				<!-- Flux360 Watermark -->
				<!-- <Watermark v-if="!maximizedVideoPanelVisible && enableWatermark"/> -->

			</md-app-content>

			<!-- Sidebar -->
			<md-app-drawer :md-active="comVisible" v-if="isOnboardingComplete" md-right md-persistent="full">
				<Sidebar/>
			</md-app-drawer>

		</md-app>
	</Fullscreen>	
</template>


<script>
// Icons
import Fullscreen from "vue-fullscreen/src/component.vue"
import FullScreenIcon from 'vue-material-design-icons/Fullscreen.vue'
import FullScreenExitIcon from 'vue-material-design-icons/FullscreenExit.vue'
import MonitorShareIcon from 'vue-material-design-icons/MonitorShare.vue'
import ShareIcon from 'vue-material-design-icons/ShareVariant.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import Login from 'vue-material-design-icons/Login.vue'
import MapOutline from 'vue-material-design-icons/MapOutline.vue'
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue'

// Components
import Flux360 from "@/components/flux360/Flux360.vue";
import MapDialogue from "@/components/flux360/MapDialogue.vue";
import MediaController from "@/components/flux360/MediaController.vue";
import SituationGallery from "@/components/flux360/SituationGallery.vue";
import TourInfo from "@/components/flux360/TourInfo.vue";
import Watermark from '@/components/flux360/Watermark.vue';
import ShareDialogue from '@/components/flux360/ShareDialogue.vue';
import ScreenSharingPanel from '@/components/flux360/ScreenSharingPanel.vue';
import LoginDialogue from "@/components/flux360/LoginComponents/LoginDialogue.vue";
import WebsiteDialogue from "@/components/flux360/WebsiteDialogue.vue";
import Viewer3D from "@/components/flux360/Viewer3D.vue";
import VideoGallery from "@/components/flux360/VideoGallery.vue";
import MeetingRegister from "@/components/flux360/MeetingRegisterDialogue.vue";
import ForcedDisconnect from "@/components/flux360/ForcedDisconnect.vue";
import WaitForModerator from "@/components/flux360/WaitForModerator.vue";
import BugReportDialogue from "@/components/flux360/BugReportDialogue.vue";
import DisclaimerDialogue from "@/components/flux360/DisclaimerDialogue.vue";
import Loadingscreen from "@/components/flux360/Loadingscreen.vue";
import MaximizedVideoPanel from "@/components/flux360/MaximizedVideoPanel";
import TransitionPreview from "@/components/flux360/TransitionPreview";
import Sidebar from "@/components/flux360/SidebarComponents/Sidebar.vue";
import ModeratorMenu from "@/components/flux360/ModeratorMenu";
import Praxisvortraege from "@/components/flux360/Venjakob/Praxisvorträge";
import StreamingVideo from "@/components/flux360/Venjakob/StreamingVideo";
import ReceptionStream from "@/components/flux360/Venjakob/ReceptionStream";
import Betriebsfuehrung from "@/components/flux360/Venjakob/Betriebsführung";
// import AudioVideoDialogue from "@/components/flux360/AudioVideoDialogue";

import {mapGetters, mapState, mapMutations} from 'vuex'
import { Prefab } from "@/store/flux360/PrefabDataTypes";

export default {
	components: {
		ShareIcon, Fullscreen, Flux360, MapDialogue, TourInfo,MediaController, SituationGallery, ChevronDown, Sidebar,AccountGroup,ModeratorMenu,VideoGallery,MeetingRegister,
		ChevronUp, ChevronRight, FullScreenIcon, FullScreenExitIcon, Watermark, ShareDialogue, MonitorShareIcon, ForcedDisconnect,MapOutline,WaitForModerator,Praxisvortraege,
		ScreenSharingPanel, LoginDialogue, Login, WebsiteDialogue, Viewer3D, DisclaimerDialogue, Loadingscreen, BugReportDialogue, MaximizedVideoPanel, TransitionPreview, 
		StreamingVideo, ReceptionStream, Betriebsfuehrung
	},
	data: () => ({
		comVisible: false,
		fullScreen: false,
		sharingVisible: false,
		messageVisible: false,
		situationGalleryVisible: false,
		infoVisible: false,
		mediaControlsVisible: false,
		mapVisible: false,
		screenSharingVisible: false,
		loginDialogueVisible: true,   
		loggedIn: false,
		bugReportVisible: false,
		maximizedVideoPanelVisible: false,
		gyrosActive: false,
		gyrosSupported: false,
	}),
	mounted: function(){
		let originalURL = new URL(window.location);
        let search_params = originalURL.searchParams;
        if(search_params.get("sessionID") == "none" )
			this.loginDialogueVisible = false;
	},
   	computed: {
		...mapState(['vrMode']),
    	...mapGetters([
			'currentSituation','numberOfChatMessages', 'localUser', 'currentPrefabs','enableWatermark','enableCommunication','enableBugReport','enableSharing',
			'enableMap','enablePermanentPanoramaVideoControls','primaryColor','secondaryColor',"fontFamily",'isDialogueOpen','loadingscreenVisible','currentSituationID','scene','users'
		]),
		currentSituationName: {
			get() {
				if(this.$store.getters.currentSituation)
					return this.$store.getters.currentSituation.getName();
				return "Undefined";
			},
		},
      ...mapState({
			openTokSession: (state) => state.session.openTokSession,
			openTokStreams: (state) => state.session.openTokStreams,
			isOnboardingComplete: (state) => state.session.isOnboardingComplete,
			isOpenTokSessionConnnected: (state) => state.session.isOpenTokSessionConnnected,
		}),
		displayScreenSharing() {
			return this.openTokSession && (this.localUserIsModerator || this.screenCastsAvailable );
		},
		localUserIsModerator () {
			if (this.localUser && this.localUser.getRole() === "moderator" )
				return true;
			return false;
		},
		screenCastsAvailable() {
			if(this.openTokStreams.find( x => x.videoType === 'screen' ))
				return true;
			return false;
		},
		screenSharingVisibleOrNoScreens() {
			return this.screenSharingVisible && ( this.localUserIsModerator || this.screenCastsAvailable );
		},

		// checks if currentSituation contains panorama video and if so checks if neccessary video data is loaded 
		// needed to display mediaController UI properly
		isVideoPanorama(){
			//Check if currentSituation contains panorama video if not return false
			let b =  this.currentSituation ? this.currentSituation.getType() == Prefab.PrefabType.SituationVideo: false;
			if(!b)
				return false;
			
			//return true when neccessary panorama video data is loaded (duration)
			return this.currentSituation.runtimeState.duration > 0;
		},
	},
	watch: {
		screenCastsAvailable: function(){
			if(!this.localUserIsModerator && !this.screenCastsAvailable)
				this.toggleScreenSharing(false,false);	
		},
		enableCommunication: function(){
			if(!this.enableCommunication)
				this.toggleLoginDialogue();
		},
		primaryColor: function(){
			document.documentElement.style.setProperty('--primaryColor', this.primaryColor);
		},
		secondaryColor: function(){
			document.documentElement.style.setProperty('--secondaryColor', this.secondaryColor);
		},
		fontFamily: function(){
			document.documentElement.style.setProperty('--primaryFont', this.fontFamily);
		},
		isOpenTokSessionConnnected: function (newV, old) { 
            console.log("OpentokSessionConnected !!!!!!!!!!!!!!!!!!!!!!!!!!! " + old + " - " + newV );
            console.log("autoConnect: " + this.autoConnect)
            if(newV===false && this.autoConnect===true){
                this.autoConnect = false;
                console.log("Calling SignIn")
                   setTimeout(() => { 
                        this.pressSignIn()}, 1000)
               
            }
             
        },
	},
	methods: {
		...mapMutations(["setDialogueOpen"]),

		onbeforeunload(e) {
			e.preventDefault(); 
			e.returnValue = ' ';
			window.returnValue = ' ';
			return ' '
		},

		// Toggle-functions for dialogues
		// garbage code needs refatoring
		toggleLoginDialogue(){
			this.loginDialogueVisible = !this.loginDialogueVisible;	
			this.setDialogueOpen(this.loginDialogueVisible);
			if(this.loginDialogueVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}						
		},
		toggleMediaControls() {
			this.mediaControlsVisible = !this.mediaControlsVisible;
			this.setDialogueOpen(false);
			if(this.mediaControlsVisible ){
				this.situationGalleryVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}
		},
		toggleGallery() {
			this.situationGalleryVisible = !this.situationGalleryVisible;
			this.setDialogueOpen(false);
			if(this.situationGalleryVisible){
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}
		},
		toggleBugReport(){
			this.bugReportVisible = !this.bugReportVisible;
			this.setDialogueOpen(this.bugReportVisible);	
			if(this.bugReportVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
			}
		},
		toggleSharing() {
			this.sharingVisible = !this.sharingVisible;
			this.setDialogueOpen(this.sharingVisible);	
			if(this.sharingVisible ){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}
		},
		toggleMap(){
			this.mapVisible = !this.mapVisible;
      		this.setDialogueOpen(this.mapVisible);
			this.mapVisible ? document.body.style.overscrollBehaviorY = "contain": document.body.style.overscrollBehaviorY = "auto";
			if(this.mapVisible){
				document.getElementsByClassName("md-container-specific")[0].style.width = "";
				document.getElementsByClassName("md-container-specific")[0].style.top = "";
				document.getElementsByClassName("md-container-specific")[0].style.left = "";
			}
			if(this.mapVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.bugReportVisible = false;
			}
		},
		toggleScreenSharing (event, value = !this.screenSharingVisible) {
			this.screenSharingVisible = value;
			this.setDialogueOpen(this.screenSharingVisible);	
			if( this.screenSharingVisible ) {
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}
		},		
		
		toggleFullScreen () {
			this.$refs['fullscreen'].toggle();
		},
		toggleCommunication(){
			this.comVisible = !this.comVisible
		},
		toggleVRMode() {
			this.$store.commit('setVRMode', !this.vrMode );
		},
		fullscreenChange(fullscreen) {
			this.fullScreen = fullscreen
		},
		toggleMediaButton(value){
			this.mediaButtonVisible = value;
		},
		onbeforeunload(e) {e.preventDefault(); e.returnValue = ' ';window.returnValue = ' ';return ' '},
		toggleLogin(){
			this.loggedIn = !this.loggedIn;
			this.toggleLoginDialogue();
			// if(this.loggedIn)
			// 	window.addEventListener("beforeunload",this.onbeforeunload);
			// else
			// 	window.removeEventListener("beforeunload",this.onbeforeunload);
		},
    	toggleMaximizedVideoPanel() {
			this.maximizedVideoPanelVisible = !this.maximizedVideoPanelVisible;
			this.setDialogueOpen(this.maximizedVideoPanelVisible);
			this.comVisible = this.maximizedVideoPanelVisible ? false: true;			
		},
		toggleGyros(){
			this.gyrosActive = !this.gyrosActive;
			this.$store.commit('activateGyros',this.gyrosActive);
		},


		pressSignIn(){
          console.log("Press Sign-In")

          const name = this.$store.getters.localUser.name;
          const acronym = this.$store.getters.localUser.acronym;
          // Note: this will create an OpenTok session if none exits.
          this.connect = this.$store.dispatch('changeNameAndAcronym', {name, acronym});
       
	      this.connect.then(() => {
          console.log(`Logged in `);
	      }).catch(function (e) {
        	if(e.message === "Login Error"){
            document.getElementById("login-error").innerText = "Die Email und/oder das Passwort ist falsch.";
            }
            console.log(e); 
      		});

            this.$root.$on('publisherCompleted', (publisher) => {
            	self.publisher = publisher;
            	self.addAudioLevelListenerForPublisher();
        	});
        	this.$root.$emit('updateAudioVideo');
        	this.$store.commit('setIsOnboardingComplete', true);
        },
        
        pressHangUp(){
			console.log("Trying to hang-up")
          const self = this;
			let logoff = null;
			if (this.$store.getters.localUser.getRole() === 'moderator') {
				logoff = this.$store.dispatch('logOffFromCms');
			} else {
				logoff = this.$store.dispatch('disconnectOpenTok');
			}
            this.$root.$emit('disconnectedOnPurpose');
			console.log(`Hanging up call for role ${this.$store.getters.localUser.getRole()}`);
			logoff
					.then(() => {
						return this.$store.dispatch('initialize');
					})
					.then(() => {

            console.log("Users to be removed: " + this.users.length);
            console.log("Local User ID: " + this.$store.state.flux360.localUserID);
            let userToBeRemoved = [];
            this.users.forEach((u) => {
              console.log("user " + u.id);
              if(u.id !== this.$store.state.flux360.localUserID){
                userToBeRemoved.push(u.id);
              }
            });
            userToBeRemoved.forEach((id) => {
              self.$store.commit("removeUser", id);
            })
				console.log('Call hung up');
			})					
        },


        changeSession(newID){
            console.log("ChangeSession to " + newID)

            this.$store.commit( 'setSessionID', newID)
        
              this.$store.dispatch('setupDefaultChatRooms', newID)
                   this.autoConnect = true;
                 setTimeout(() => {
                        this.pressHangUp()},1000)

        }



	},
	created: function(){
		console.defaultLog = console.log.bind(console);
        console.logs = [];
        console.error = function(){
            console.defaultLog.apply(console, arguments);
            console.logs.push(Array.from(arguments));
		}
		//check if gyros supported
		if (window.DeviceOrientationEvent && 'ontouchstart' in window)
			this.gyrosSupported = true;
		
		},
	provide() {
		return {
			toggleMap: this.toggleMap,
			toggleSharing: this.toggleSharing,
			toggleGallery: this.toggleGallery,
			toggleInfo: this.toggleInfo,
			toggleLoginDialogue: this.toggleLoginDialogue,
			toggleLogin: this.toggleLogin,
			toggleCommunication: this.toggleCommunication,
			toggleBugReport: this.toggleBugReport,
			toggleMaximizedVideoPanel: this.toggleMaximizedVideoPanel,
			toggleScreenSharing: this.toggleScreenSharing,
			changeSession: this.changeSession,
		}
	},
}
</script>


<style>
:root{
	--primaryColor: #E76101;
  	--secondaryColor: #a34400;
	--primaryFont: Avenir;
	--md-theme-default-primary: var(--primaryColor);
}

::selection {
	background: var(--primaryColor)! important;
}
::-moz-selection { 
	background: var(--primaryColor) !important;
}

body {
  	font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

html, body {
	height: 100% !important;
}

.full-screen {
	height: 100% !important;
	width: 100% !important;
}
.normal-md-button, .accent-md-button{
  	min-width: 75px;
}
.normal-md-button{
	background-color: rgb(50, 50, 50) !important;
	--md-theme-default-text-primary-on-background: white;
	border-radius: 4px;
	margin: 2px;
}

.normal-md-button:disabled *{
  	color: #868686;
}

.accent-md-button{
	background-color: var(--primaryColor);
	border-radius: 4px;
	margin: 2px;
	--md-theme-default-text-primary-on-background: white;
}
.accent-md-button:disabled{
  opacity: 0.4;
  background-color: rgb(67, 67, 67);
  --md-theme-default-disabled-on-background: white;
}
#audio-video-settings{
  position: absolute;
  z-index: 2;
  background: rgba(57, 56, 56, 0.8);
  --md-theme-default-background: transparent;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  min-height: 100%;
  min-width: 100%;
}
.audio-video-settings *{
  --md-theme-default-text-primary-on-background: white;
  color: white;
}
.md-ripple{
  z-index: 0 !important;
}
.md-checkbox.md-theme-default .md-checkbox-container{
  border-color: white;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: white !important;
  z-index: 2;
}
@-moz-document url-prefix() {
  #audio-video-settings{
    background: rgba(55, 55, 55, 0.95);
  }
}
.md-title{
  color: white;
}
.md-field > .md-input{
  background: rgba(36, 36, 36, 0.4);
  margin-top: 5px;
  transition: none;
  height: 30px;
  width: 100%;
  border-radius: 3px;
  border: 0;
  box-shadow: none;
  padding-left: 12px;
}
.md-select{
  background: rgba(36, 36, 36, 0.4);
  margin-top: 5px;
  transition: none;
  width: 100%;
  border-radius: 3px;
  border: 0;
  box-shadow: none;
  padding: 2px 2px 2px 8px;
}
.md-focused .md-select{
  padding: 0 0 0 6px;
  border: 2px solid var(--primaryColor);
  outline: none;
}
.font-awesome-icon{
  color: white;
}
.md-field > .md-input:focus{
  padding: 10px;
  border: 2px solid var(--primaryColor);
  outline: none;
}
.md-field.md-focused label{
  font-size: 1em;
  margin-bottom: 15px;
  padding-bottom: 15px;
}
.md-field.md-has-value label{
  font-size: 1em;
  -webkit-text-fill-color: #808080;
}
.md-field.md-required label:after{
  all: unset;
}
.md-dialog-container{
  box-shadow: none;
}
.md-icon-button:hover::before{
  background-color: #1d1d1d;
  border-radius: 2px;
}
.md-app-content {
	padding: 0px;
	border-left: 0px;
	border-right: 0px;
}

.tourInfo{
	display: flex;
	border-radius: 5px;
	background: rgba(48, 47, 47, 0.767);
	align-items: center;
	min-width: 200px;
	max-width: 200px;
	margin-top: -8px;
}

#newMessages{
  width: 1em;
  height: 1em;
  position: relative;
  left: 15px;
  top: 5px;
  color: white;
  border-radius: 200px;
  background-color: var(--primaryColor);
}

.md-app {
	overflow: hidden;
}

.md-app-container {
	overflow: hidden;
	transform: translate3D(0,0,0);
    transition: padding-left .4s cubic-bezier(.25,.8,.25,1),padding-right .4s cubic-bezier(.25,.8,.25,1);
    will-change: padding-left,padding-right;
}

.md-drawer.md-active {
	transform: translate3D(0,0,0);
	transition: height .5s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1);
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
}

.md-app-content {
	border-left: 0px;
	overflow: hidden;
}

#content {
	position: relative;
	top: 0px;
	left: 0px;
}

.md-app-content {
	padding: 0px;
}

.flux-nav-toolbar {
	float: left;
	width: 100%;
	/*position: absolute;*/
	left: 0;
	top: 0;
	flex-wrap: nowrap;
	flex-direction: row;
	align-items: baseline;
	flex-grow: 1;
	flex-shrink: 0;
	padding-right: 0px;
	padding-top: 20px;
}

.flux-nav-toolbar * .md-button {
	margin: 0;
	padding: 0;
}

.flux-nav-toolbar * .md-icon-button {
	border-radius: 3px;
	background-color: transparent;
	filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.5)) drop-shadow(0px 0px 10px rgba(0,0,0,0.5));
	height: 50px;
	width: 60px;
}

.flux-nav-toolbar * .md-icon-button .md-ripple {
	padding: 0;
	border-radius: 3px;
}

.md-toolbar{
	padding-left: 0;
}

.active {
	background-color: var(--primaryColor) !important;
}

.flux-nav-toolbar * .inactive {
	background-color: rgba(48, 47, 47, 0.767);
}

@keyframes notification-animation {
  from {background-color: transparent;}
  to {background-color: var(--primaryColor);}
}

.flux-nav-toolbar * .notification {
	background-color: transparent;
	animation-name: notification-animation;
	animation-duration: 0.5s;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}

.clearfix::after {
	display: block;
	clear: both;
}

.material-design-icon {
	height: 2em;
	width: 2em;
}

.material-design-icon > .material-design-icon__svg {
	height: 2em;
	width: 2em;
	fill: white;
}

.material-design-icon.mapIcon {
  height: 2.3em;
  width: 2.3em;
}
 
.material-design-icon.mapIcon> .material-design-icon__svg {
  height: 2.3em;
  width: 2.3em;
}

.slideup, .slidedown {
	max-height: 0;
	overflow-y: hidden;
	-webkit-transition: max-height 0.3s ease-in-out;
	-moz-transition: max-height 0.3s ease-in-out;
	-o-transition: max-height 0.3s ease-in-out;
	transition: max-height 0.3s ease-in-out;
}

.slidedown {
	max-height: 300px;
}

.video-panel {
	height: 40%;
	background: #434346;
	color: white;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .4s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
.fadeLoadingscreen-enter-active{
	transition: opacity .5s;
}
.fadeLoadingscreen-leave-active {
	transition: opacity 1s;
}
.fadeLoadingscreen-enter, .fadeLoadingscreen-leave-to {
	opacity: 0;
}
.situationName{
	line-height: 30px;
	padding-top: 10px;
	cursor: pointer; 
	font-size: 2vw; 
	color: white;
}

.navbar.center{
	justify-content: center;
    align-items: flex-start;
}

#Trigger{
	padding-left: 0px;
	margin-left: 0px;
}

.md-overlay{
	display:none;
}
.disablePointer{
	pointer-events: none;
}
.enabelPointer{
	pointer-events: all;
}
.fullscreenVideoPanel{
	height: 100% !important;
}
.corner-right{
	position: absolute; 
	bottom: 1%; 
	right: 1%;
}

/*MOBILE*/
@media (max-device-width: 900px){
	.flux-nav-toolbar {
		padding-top: 10px;
	}
	.situationName{
		font-size: 25px;
	}
	.corner-right{
		top: 15px;
	}
}

@media (max-width: 1600px){
	.situationName{
		font-size: 25px;
	}
}
</style>